'use client';

import { create } from 'zustand';

interface SearchState {
  isOpen: boolean;
  initialQuery: string;
  open: () => void;
  openWith: (query: string) => void;
  close: () => void;
}

export const useSearchStore = create<SearchState>((set) => ({
  isOpen: false,
  initialQuery: '',
  open: () => set({ isOpen: true, initialQuery: '' }),
  openWith: (query: string) => set({ isOpen: true, initialQuery: query }),
  close: () => set({ isOpen: false, initialQuery: '' }),
}));
